import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {SharedModule} from 'app/shared/shared.module';
import {DndModule} from 'ng2-dnd';
import {VenuesComponent} from './components/venues.component';
import {VenueAddComponent} from './components/add/venue-add.component';
import {VenueEditComponent} from './components/edit/venue-edit.component';
import {FormService} from '../../../shared/components/form/form.service';
import {VenuesService} from './venues.service';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        DndModule.forRoot()
    ],
    declarations: [
        VenuesComponent,
        VenueAddComponent,
        VenueEditComponent
    ],
    providers: [
        FormService,
        VenuesService
    ],
    entryComponents: [
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})
export class VenuesModule {
}



// WEBPACK FOOTER //
// ./src/app/organization/components/venues/venues.module.ts